import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import PWAPrompt from "@/components/PWAPrompt.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import PlacesListFromCodes from "@/components/PlacesListFromCodes.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainLayout, null, {
      default: _withCtx(() => [
        _createVNode(PWAPrompt),
        _createVNode(PlacesListFromCodes)
      ]),
      _: 1
    })
  ]))
}
}

})